export default {
  en: {
    segments: {
      title: 'Services',
      subtitle: 'Select a service you want to contact.',
      names: 'Example',
    },
    forms: {
      title: 'Personal data 📄',
      subtitle: 'For more personalized attention please provide some details about yourself.',
      empty: 'Not exist form for the selected department. Please modify template for view.',
    },
  },
  es: {
    segments: {
      title: 'Servicios',
      subtitle: 'Seleccione el servicio que desea contactar.',
      names: 'Ejemplo',
    },
    forms: {
      title: 'Información 📄',
      subtitle: 'Para una atención más personalizada por favor, proporcione unos detalles sobre usted.',
      empty: 'No hay formulario para el departamento seleccionado. Modique la plantilla para visualizar.',
    },
  },
  fr: {
    segments: {
      title: 'Services',
      subtitle: 'Sélectionnez le service que vous souhaitez contacter.',
      names: 'Example',
    },
    forms: {
      title: 'Informations 📄',
      subtitle: 'Pour un service plus personnalisé, veuillez fournir quelques détails sur vous-même.',
      empty: 'Aucun formulaire pour le département sélectionné. Modifiez le modèle pour afficher.',
    },
}

};
